import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.afterEach((to) => Vue.prototype.$gtm.trackView(to.path, to.name, true));

export default router;
